import {
  BULK_LISTING_ENABLED_ENDPOINT,
  BULK_LISTING_ENDPOINT,
} from '@/constants/endpoints';
import { type CurrencyCode } from '@/modules/currencies/constants';
import http from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types';
import { type BulkListingEnabledStatus } from '@/modules/user/types';

export async function getBulkListingData(): Promise<
  AxiosCompatibleResponse<BulkListingEnabledStatus>
> {
  return http.get(BULK_LISTING_ENABLED_ENDPOINT, { withAuth: true });
}

export async function uploadBulkListingCsv({
  csvAsBase64String,
  priceCurrency,
  langTag,
  country,
}: {
  csvAsBase64String: string;
  priceCurrency: CurrencyCode;
  langTag: string;
  country: string;
}): Promise<AxiosCompatibleResponse> {
  const reqBody = {
    priceCurrency,
    data: csvAsBase64String,
    country,
  };

  const headers = {
    ...(langTag && {
      'Accept-Language': langTag,
    }),
  };

  return http.post(BULK_LISTING_ENDPOINT, reqBody, {
    headers,
    withAuth: true,
  });
}
